import { QueryDef } from "../type/query-def";
import { finestGrain, sortGrainsCoarseToFine } from "../time-grain";

export class QueryAdapter {
  static toOutputDTO(res: any): QueryDef {
    const subjectAttrs =
      res.subject_attrs
        // v3 は登録済み全属性を返す。データの無い (options 空) 属性は絞り込めない
        // ので除外する。これを残すと zod の attrs.some(value) refine が必ず失敗し
        // querybar 全体が送信不能になる。
        ?.filter((attr: any) => (attr.options?.length ?? 0) > 0)
        .map((attr: any) => ({
          id: attr.id,
          key: attr.name,
          attrs:
            attr.options?.map((option: any) => ({
              id: option.id,
              key: option.value,
              // 表示は v3 の value_label を優先 (config-def に無い汎用属性向け)。
              label: option.value_label ?? option.value,
              value: true,
            })) || [],
        })) || [];

    const subjectGroups =
      res.subject_groups?.map((group: any) => ({
        id: group.id,
        key: group.name,
        attrs: [
          { id: 0, key: "no_filter", value: true },
          ...(group.options?.map((option: any) => ({
            id: option.id,
            key: option.value,
            value: false,
          })) || []),
        ],
      })) || [];

    let newId = 1;
    const subjects = [
      ...subjectAttrs.map((attr: any) => ({
        id: newId++,
        key: attr.key,
        value: false,
      })),
      ...subjectGroups.map((group: any) => ({
        id: newId++,
        key: group.key,
        value: false,
      })),
    ];

    return {
      subject_attrs: subjectAttrs,
      subject_groups: subjectGroups,
      subjects: subjects,
      // backend が返す vendor の実粒度を使う (旧実装は day/week/month をハードコードしており、
      // 分粒度の vendor でも one_day を送っていた)。既定選択は最も細かい粒度
      // (従来 day/week/month の既定が day = 最細だったのを踏襲)。
      time_grain: (() => {
        const keys = sortGrainsCoarseToFine(
          res.time_granularities?.length ? res.time_granularities : ["one_day"]
        );
        const finest = finestGrain(keys);
        return keys.map((key: string, index: number) => ({
          id: index + 1,
          key,
          value: key === finest,
        }));
      })(),
      time_range: {
        start: new Date(res.time_range.start),
        end: new Date(res.time_range.end),
      },
      is_noapps: res.is_noapps,
    };
  }
}
